import { render, staticRenderFns } from "./PlaylistDetailsPage.vue?vue&type=template&id=bb4eec1c&scoped=true&"
import script from "./PlaylistDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PlaylistDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistDetailsPage.vue?vue&type=style&index=0&id=bb4eec1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4eec1c",
  null
  
)

export default component.exports